define('commons/city-area-info',['jquery', 'async!google-maps'], function($) {

    var CityArea = function(data, cityAreaMap) {
        this.map= cityAreaMap;

        var colorBlue = '#86adf1';
        var colorPurple = '#830080';
        var colorOrange = '#ff8c00';

        var options = {
                fillColor: colorBlue,
                fillOpacity: 0.15,
                strokeColor: colorBlue,
                strokeWeight: 1,
                editable: false,
                draggable: false
            };
        var urban = $.extend([], options, {strokeColor: colorPurple, fillColor: colorPurple, zIndex: 10});
        var suburban = $.extend([], options, {strokeColor: colorOrange, fillColor: colorOrange, zIndex: 1});

        // save created circle
        this.circles = [];
        this.circleIndex = 0;

        this.bounds = null;

        // save created polygons
        this.polygons = [];
        this.polygonIndex = 0;

        var infoCircle = new google.maps.InfoWindow({maxWidth: 100});

        this.drawCircle = function(name, centerLat, centerLng, width, isUrban) {
            var latLngCenter = new google.maps.LatLng(centerLat, centerLng);
            var latLngRight = new google.maps.LatLng(latLngCenter.lat(), latLngCenter.lng() + (width/2));
            var options = {
                map : this.map,
                clickable: true,
                center : latLngCenter,
                radius : google.maps.geometry.spherical.computeDistanceBetween(latLngCenter, latLngRight)
            };
            var colors;
            if (isUrban) {
                colors = urban;
            } else {
                colors = suburban;
            }

            var circle = new google.maps.Circle($.extend([], options, colors));
            circle.index = this.circleIndex;

            if (isUrban) {
                circle.type = "urban";
            } else {
                circle.type = "suburban";
            }
            circle.name = name;

            google.maps.event.addListener(circle, "click", $.proxy(function(e) {
                var display = circle.name ? circle.name : "circle " + (circle.index + 1);
                infoCircle.setContent(display);
                infoCircle.setPosition(circle.center);
                infoCircle.open(this.map);
            }, this));
            
            this.circles[this.circleIndex] = circle;
            if (this.circleIndex === 0) {
                this.bounds = circle.getBounds();
            } else {
                this.bounds = this.bounds.union(circle.getBounds());
            }
            this.circleIndex++;
        };

        var polygonBounds = function(polygon) {
            var latLng;
            var bounds;
            var path = polygon.getPath();
            for (k = 0; k < path.getLength(); k ++) {
                latLng = new google.maps.LatLng(path.getAt(k).lat(), path.getAt(k).lng());
                if (k === 0) {
                    bounds = new google.maps.LatLngBounds(latLng, latLng);
                } else {
                    bounds = bounds.extend(latLng);
                }
            }
            return bounds;
        };
        var infoPolygon = new google.maps.InfoWindow({maxWidth: 100});

        this.drawPolygon = function(name, coords, isUrban) {
            var paths = [];
            for (k = 0; k < coords.length; k++) {
                paths[k] = new google.maps.LatLng(coords[k].lat, coords[k].lng);
            }
            var options = {
                map: this.map,
                paths : paths
            };
            var colors;
            if (isUrban) {
                colors = urban;
            } else {
                colors = suburban;
            }
            var polygon = new google.maps.Polygon($.extend([], options, colors));
            polygon.index = this.polygonIndex;

            if (isUrban) {
                polygon.type = "urban";
            } else {
                polygon.type = "suburban";
            }
            polygon.name = name;

            google.maps.event.addListener(polygon, "click", $.proxy(function(e) {
                var display = polygon.name ? polygon.name : "polygon " + (polygon.index + 1);
                infoPolygon.setContent(display);
                infoPolygon.setPosition(polygon.getPath().getAt(0));
                infoPolygon.open(this.map);
            }, this));

            this.polygons[this.polygonIndex] = polygon;
            if (!this.bounds) {
                this.bounds = polygonBounds(polygon);
            } else {
                this.bounds = this.bounds.union(polygonBounds(polygon));
            }
            this.polygonIndex++;
        };
        
        if (data) {
            this.load(data);
        }

        if(this.bounds) {
            this.map.fitBounds(this.bounds);
        }
    };

    CityArea.prototype.load = function(data, opacity) {
        this.clean();
        for(var i = 0; i < data.circles.length; i++) {
            var circle = data.circles[i];
            this.drawCircle(circle.name, circle.center.lat, circle.center.lng, circle.width, circle.urban);
        }

        for(var j = 0; j < data.polygons.length; j++) {
            var polygon = data.polygons[j];
            this.drawPolygon(polygon.name, polygon.coords, polygon.urban);
        }
        this.updateOpacity(opacity);
    };

    CityArea.prototype.clean = function() {
        for (var index = 0; index < this.circleIndex; index++) {
          var c = this.circles[index];
          if(c) {
              c.setMap(null);
              this.circles[index] = null;
          }
        }        
        for (var index = 0; index < this.polygonIndex; index++) {
          var p = this.polygons[index];
          if(p) {
            p.setMap(null);
            this.polygons[index] = null;
          }
        }
    };

    CityArea.prototype.updateOpacity = function(opacity) {
        for (var index = 0; index < this.circleIndex; index++) {
          var c = this.circles[index];
          if(c) {
              c.setOptions({'fillOpacity': opacity});
          }
        }        
        for (var index = 0; index < this.polygonIndex; index++) {
          var p = this.polygons[index];
          if(p) {
              p.setOptions({'fillOpacity': opacity});
          }
        }
    };
    
    return CityArea;
});

